import dynamic from 'next/dynamic'

export const StepBlackWaitlist = dynamic(() => import('./step-black-waitlist'))
